import { __assign, __rest } from "tslib";
import React from 'react';
import { Google } from '../icons';
import { Button } from '../Button';
export var GoogleLogoButton = React.forwardRef(function (props, ref) {
    var buttonProps = __rest(props, []);
    return (React.createElement(Button, __assign({ ref: ref }, buttonProps, { variant: "google" }),
        React.createElement(Google, null)));
});
GoogleLogoButton.displayName = 'GoogleLogoButton';
//# sourceMappingURL=GoogleLogoButton.js.map